import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../img/logo.png'; // Assuming this is the logo for the Navbar
import page404_icon from '../../img/404_image.png'; // The 404 image
import Navbar from '../navbar/Navbar';

import '../../css/onBoarding/page404.css';

const Page404 = () => {
  return (
    <div className='min-h-screen flex flex-col'>
      {/* Navbar */}
      <Navbar />

      {/* Main Content */}
      <div className='page-404-wrapper-div flex flex-1 items-center justify-between'>
        {/* Left Section */}
        <div className='flex flex-col items-start w-auto'>
          {/* Heading */}
          <h1 className='heading-404 leading-tight'>
            We can't find the page <br /> you're looking for.
          </h1>

          {/* Link Button */}
          <Link
            to='/overview'
            className='link-button-404 mt-4 px-6 py-3 transition'
          >
            Go to Homepage
          </Link>
        </div>

        {/* Right Section */}
        <div className='hidden md:block ml-8'>
          <img
            src={page404_icon}
            alt='404 Page Icon'
            className='img-404 max-w-full h-auto'
          />
        </div>
      </div>
    </div>
  );
};

export default Page404;
